module.exports = {
  loginTitle: 'CRO System',
  loginBtn: 'Sign-in',
  logout: '退出',
  logoTip: '确定退出吗？',
  oktaError: '您未经授权，请联系管理部门'
}
